<div class="data-delete">
  <p class="warning-text">
    <mat-icon>warning</mat-icon>
    Permanently deletes ALL member related data registered in the selected period (maximum {{maxDeletePeriodMonths}} months). This action cannot be undone.
  </p>

  <div class="search-form">
    <mat-form-field appearance="outline" class="m-2">
      <mat-label>Date From/Until</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="From" [(ngModel)]="dateFrom">
        <input matEndDate placeholder="Until" [(ngModel)]="dateUntil">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-raised-button color="warn" (click)="delete()" [disabled]="!!periodError || isBusy" class="report-btn"> <mat-icon>delete_forever</mat-icon> Delete </button>
  </div>

  <p class="period-error" *ngIf="dateFrom && dateUntil && periodError">{{periodError}}</p>
</div>
